import { z } from "zod";
const funnelIdSchema = z.uuid().brand();
function asFunnelId(id) {
  return funnelIdSchema.parse(id);
}
const funnelInteractionIdSchema = z.uuid().brand();
function checkFunnelUiVisible(variant) {
  return variant !== "hidden";
}
function checkFunnelUiWritable(variant) {
  return variant === "readwrite";
}
function checkFunnelLabelingAutomated(variant) {
  return variant === "automated";
}
const FunnelInductionStatus = {
  Pending: "pending",
  Complete: "complete",
  Failed: "failed"
};
const allFunnelInductionStatuses = [
  FunnelInductionStatus.Pending,
  FunnelInductionStatus.Complete,
  FunnelInductionStatus.Failed
];
const funnelInductionStatusSchema = z.enum(allFunnelInductionStatuses);
const FunnelCohort = {
  Agent: "agent",
  TopRep: "top_rep"
};
const allFunnelCohorts = [
  FunnelCohort.Agent,
  FunnelCohort.TopRep
];
const funnelCohortSchema = z.enum(allFunnelCohorts);
const FunnelInteractionStatus = {
  Labeled: "labeled",
  Skipped: "skipped",
  SkippedTooLong: "skipped_too_long"
};
const allFunnelInteractionStatuses = [
  FunnelInteractionStatus.Labeled,
  FunnelInteractionStatus.Skipped,
  FunnelInteractionStatus.SkippedTooLong
];
const funnelInteractionStatusSchema = z.enum(
  allFunnelInteractionStatuses
);
const FunnelExchangeEnding = {
  Unresolved: "unresolved",
  Resolved: "resolved",
  HandedOff: "handed_off",
  DroppedOff: "dropped_off"
};
const allFunnelExchangeEndings = [
  FunnelExchangeEnding.Unresolved,
  FunnelExchangeEnding.Resolved,
  FunnelExchangeEnding.HandedOff,
  FunnelExchangeEnding.DroppedOff
];
const funnelExchangeEndingSchema = z.enum(allFunnelExchangeEndings);
const FunnelTurnRole = {
  Agent: "agent",
  Rep: "rep",
  Caller: "caller",
  Tool: "tool"
};
const allFunnelTurnRoles = [
  FunnelTurnRole.Agent,
  FunnelTurnRole.Rep,
  FunnelTurnRole.Caller,
  FunnelTurnRole.Tool
];
const funnelTurnRoleSchema = z.enum(allFunnelTurnRoles);
const funnelStageSchema = z.object({
  key: z.string(),
  name: z.string(),
  /** How to tell the interaction got there. */
  description: z.string(),
  /**
   * Set on the last stage of a funnel induced against an outcome: it is the
   * outcome's success result, so it counts as reached exactly when the
   * interaction's outcome is a green result, whatever the labels say.
   */
  is_outcome_success: z.boolean().optional()
});
const funnelStagesSchema = z.array(funnelStageSchema);
const funnelMomentSchema = z.object({
  key: z.string(),
  name: z.string(),
  /** What counts, with quoted examples that count and a few that don't. */
  description: z.string()
});
const funnelMomentsSchema = z.array(funnelMomentSchema);
const funnelSnapshotTurnSchema = z.object({
  role: funnelTurnRoleSchema,
  text: z.string(),
  start_ms: z.number().int().nonnegative()
});
const funnelExtractionSchema = z.object({
  stages: z.array(
    z.object({
      name: z.string(),
      description: z.string(),
      snapshot: funnelSnapshotTurnSchema
    })
  ),
  moments: z.array(
    z.object({
      name: z.string(),
      description: z.string(),
      snapshot: z.array(funnelSnapshotTurnSchema)
    })
  )
});
export {
  FunnelCohort,
  FunnelExchangeEnding,
  FunnelInductionStatus,
  FunnelInteractionStatus,
  FunnelTurnRole,
  allFunnelCohorts,
  allFunnelExchangeEndings,
  allFunnelInductionStatuses,
  allFunnelInteractionStatuses,
  allFunnelTurnRoles,
  asFunnelId,
  checkFunnelLabelingAutomated,
  checkFunnelUiVisible,
  checkFunnelUiWritable,
  funnelCohortSchema,
  funnelExchangeEndingSchema,
  funnelExtractionSchema,
  funnelIdSchema,
  funnelInductionStatusSchema,
  funnelInteractionIdSchema,
  funnelInteractionStatusSchema,
  funnelMomentSchema,
  funnelMomentsSchema,
  funnelSnapshotTurnSchema,
  funnelStageSchema,
  funnelStagesSchema,
  funnelTurnRoleSchema
};
//# sourceMappingURL=funnel.js.map
